import { jsxs as h, jsx as t } from "react/jsx-runtime";
const a = () => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    width: "40",
    height: "40",
    children: [
      /* @__PURE__ */ t(
        "rect",
        {
          width: "40",
          height: "28",
          id: "rect2927",
          style: {
            fill: "rgb(151, 190, 13)",
            fillOpacity: 1
          },
          y: "6.403"
        }
      ),
      /* @__PURE__ */ h(
        "g",
        {
          id: "g2913",
          style: {
            fill: "rgb(255, 255, 255)"
          },
          transform: "matrix(0.10013600438833237, 0, 0, 0.10013600438833237, 0.16729199886322021, 6.308467864990234)",
          children: [
            /* @__PURE__ */ t(
              "path",
              {
                d: "M 145.62,62.7181 C 157.082,63.4373 168.392,64.7762 178.195,68.8137 169.007,72.2451 162.032,76.3014 154.055,80.0453 L 160.36,53.8903 C 165.358,63.8697 170.642,74.4742 173.425,84.4537 164.34,75.6031 155.047,69.0419 145.62,62.7181 z",
                id: "path2889"
              }
            ),
            /* @__PURE__ */ t(
              "path",
              {
                d: "M 195.933,60.0618 221.788,69.4387 201.555,78.9515 C 203.515,70.4081 205.696,61.7546 208.485,52.7966 211.421,63.8372 214.443,75.2339 216.549,85.8599 209.994,76.5742 202.869,68.5853 195.933,60.0618 z",
                id: "path2891"
              }
            ),
            /* @__PURE__ */ t(
              "path",
              {
                d: "M 247.183,69.2806 C 254.801,70.5745 262.826,70.2401 270.851,69.2824 264.282,75.1812 257.601,80.9674 250.618,86.4516 253.711,77.6835 256.589,68.7001 259.267,59.5153 261.121,68.5573 262.976,77.5992 264.83,86.6411 259.312,81.9312 253.169,76.1462 247.183,69.2806 z",
                id: "path2893"
              }
            ),
            /* @__PURE__ */ t(
              "path",
              {
                d: "M 299.058,68.4994 C 305.384,66.6256 313.586,61.8786 320.694,58.5012 314.783,66.2083 308.872,73.484 302.961,80.3578 304.934,72.4373 307.774,64.1993 310.36,55.6091 312.338,61.559 313.843,67.0447 316.549,72.4224 310.719,72.0905 304.888,70.9034 299.058,68.4994 z",
                id: "path2895"
              }
            ),
            /* @__PURE__ */ t(
              "path",
              {
                d: "M 276.87,112.874 C 287.566,110.977 294.743,107.737 303.351,104.751 295.827,112.454 286.977,122.911 280.774,127.858 L 290.36,99.8277 C 292.513,107.634 295.085,115.021 297.643,122.422 290.434,120.687 283.664,117.101 276.87,112.874 z",
                id: "path2897"
              }
            ),
            /* @__PURE__ */ t(
              "path",
              {
                d: "M 250.776,148.03 C 260.467,150.41 269.078,152.108 279.288,151.313 272.912,157.458 265.04,161.36 257.024,165.045 259.688,157.193 262.324,149.281 264.579,140.609 267.94,149.442 270.8,159.839 274.674,166.641 265.11,160.97 257.891,154.518 250.776,148.03 z",
                id: "path2899"
              }
            ),
            /* @__PURE__ */ t(
              "path",
              {
                d: "M 222.808,170.843 C 231.791,174.656 240.305,178.594 249.757,180.376 242.893,183.376 236.014,186.36 228.743,188.952 230.782,181.275 232.595,174.067 235.048,166.39 238.051,175.969 241.366,185.444 245.612,194.61 237.513,188.435 229.718,179.456 222.808,170.843 z",
                id: "path2901"
              }
            ),
            /* @__PURE__ */ t(
              "path",
              {
                d: "M 186.089,184.905 C 195.28,187.561 204.472,191.536 213.663,195.845 205.992,199.049 198.497,202.78 191.242,207.233 194.33,197.717 197.699,188.004 199.735,178.734 202.578,189.754 206.32,201.303 209.049,212.579 203.504,205.958 193.726,193.401 186.089,184.905 z",
                id: "path2903"
              }
            ),
            /* @__PURE__ */ t(
              "path",
              {
                d: "M 131.245,192.249 C 141.799,190.377 152.12,189.905 162.257,190.532 152.494,199.257 144.572,206.755 135.93,214.733 139.959,202.108 143.988,189.484 148.017,176.859 150.542,188.778 152.717,201.398 154.83,214.141 148.701,207.298 139.606,199.048 131.245,192.249 z",
                id: "path2905"
              }
            ),
            /* @__PURE__ */ t(
              "path",
              {
                d: "M 112.026,97.093 C 123.911,93.5084 135.473,93.3177 146.945,94.2822 L 120.774,111.452 C 123.604,102.421 126.352,93.3899 129.579,84.359 134.501,93.1733 138.963,101.991 142.643,110.391 134.414,104.45 123.126,100.573 112.026,97.093 z",
                id: "path2907"
              }
            ),
            /* @__PURE__ */ t(
              "path",
              {
                d: "M 89.0575,147.874 C 100.645,141.975 112.388,137.496 123.976,137.407 L 95.93,164.733 107.235,127.64 C 111.461,137.395 115.625,148.133 117.799,157.891 108.901,153.66 99.6027,150.046 89.0575,147.874 z",
                id: "path2909"
              }
            ),
            /* @__PURE__ */ t(
              "path",
              {
                d: "M 68.745,210.999 C 75.2119,208.654 86.6709,199.738 93.5228,197.777 112.706,164.866 189.74,119.381 225.587,115.732 226.594,115.63 226.477,116.341 225.628,116.589 188.038,127.557 124.927,161.934 101.319,199.282 92.241,213.643 88.6779,215.682 76.8675,229.264 80.6148,214.858 84.4477,200.424 89.4228,185.609 93.9863,196.873 97.26,208.567 100.612,220.234 91.2856,215.198 80.1533,212.288 68.745,210.999 z",
                id: "path2911"
              }
            )
          ]
        }
      )
    ]
  }
);
export {
  a as EuOrganicSymbol
};
